import React, { useEffect, useState } from 'react'
import { Modal, Select, Row, Col, Button, message } from "antd";
import { platformApi } from '../../../../api';

const { Option } = Select;

const ReassignForm = ({ open, close, data }) => {
  const [branches, setBranches] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedExecutive, setSelectedExecutive] = useState(null);
  const [loading, setLoading] = useState({
    branches: false,
    employees: false,
    assign: false
  });

  useEffect(() => {
    if (open) {
      fetchBranches();
    }
  }, [open]);

  useEffect(() => {
    if (open && data) {
      prefillData();
    }
  }, [open, data]);

  const fetchBranches = () => {
    setLoading(prev => ({ ...prev, branches: true }));
    platformApi
      .get("/api/company/branches")
      .then((result) => {
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            setBranches(response.data);
            if (data) {
              prefillData(response.data);
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
        message.error("Unable to fetch branches");
      })
      .finally(() => {
        setLoading(prev => ({ ...prev, branches: false }));
      });
  };

  const fetchEmployeesBasedOnBranch = (branchId) => {
    setLoading(prev => ({ ...prev, employees: true }));
    platformApi
      .post("/api/user/get", {
        size: 1000,
        page: 1,
      })
      .then((result) => {
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            let filteredEmployees = [];
            response.data.users.forEach((element) => {
              let sale = false;
              element.profile.department.departmentType.forEach((deptType) => {
                if (deptType === "Sales") {
                  sale = true;
                  return;
                }
              });

              if (sale) {
                let belongsToBranch = false;
                element.profile.branch.forEach((branch) => {
                  if (branch.id === branchId) {
                    belongsToBranch = true;
                    return;
                  }
                });

                if (belongsToBranch && element.status === true) {
                  filteredEmployees.push({
                    id: element.id,
                    name: element.profile.employeeName,
                    employeeId: element.profile.employeeId,
                  });
                }
              }
            });
            setEmployees(filteredEmployees);
          }
        }
      })
      .catch((error) => {
        message.error("Unable to fetch employees", 1);
        console.error("Error fetching employees: ", error);
      })
      .finally(() => {
        setLoading(prev => ({ ...prev, employees: false }));
      });
  };

  const prefillData = (branchesList = branches) => {
    if (!data) return;

    let branchToPrefill = data.assignedBranch || data.branch;
    if (branchToPrefill) {
      const branch = branchesList.find(b => b.id === branchToPrefill.id);
      if (branch) {
        setSelectedBranch({
          id: branch.id,
          name: branch.name,
        });
        fetchEmployeesBasedOnBranch(branch.id);
      }
    }

    let executiveToPrefill = data.assignedExecutive || data.executive;
    if (executiveToPrefill) {
      setTimeout(() => {
        setSelectedExecutive({
          id: executiveToPrefill.id,
          name: executiveToPrefill.profile.employeeName,
        });
      }, 100);
    }
  };

  const handleBranchChange = (value, option) => {
    const branch = {
      id: value,
      name: option.children,
    };
    setSelectedBranch(branch);
    setSelectedExecutive(null);
    fetchEmployeesBasedOnBranch(value);
  };

  const handleExecutiveChange = (value, option) => {
    const executive = {
      id: value,
      name: option.children,
    };
    setSelectedExecutive(executive);
  };

  const handleAssignExecutive = () => {
    if (!selectedBranch || !selectedExecutive) {
      message.error("Please select both branch and sales executive");
      return;
    }

    setLoading(prev => ({ ...prev, assign: true }));

    const payload = {
      branch: selectedBranch,
      executive: selectedExecutive,
      quotationId: data.id,
    };

    platformApi
      .post("/api/quotation/assignExecutive", payload)
      .then((result) => {
        setLoading(prev => ({ ...prev, assign: false }));
        const { data: responseData } = result;
        if (responseData.code === 200) {
          message.success("Executive assigned successfully");
          setSelectedExecutive(null);
          close();
        } else {
          message.error("Unable to assign executive");
        }
      })
      .catch((error) => {
        console.error("Error assigning executive: ", error);
        setLoading(prev => ({ ...prev, assign: false }));
        message.error("Unable to assign executive");
      });
  };

  const handleClose = () => {
    setSelectedBranch(null);
    setSelectedExecutive(null);
    setEmployees([]);
    close();
  };

  return (
    <Modal
      title="Reassign Executive"
      visible={open}
      onCancel={handleClose}
      width="75%"
      footer={[
        <Button key="cancel" onClick={handleClose}>
          Cancel
        </Button>,
        <Button
          key="assign"
          type="primary"
          loading={loading.assign}
          onClick={handleAssignExecutive}
        >
          Assign Executive
        </Button>,
      ]}
    >
      <div>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <div style={{ marginBottom: 8, fontWeight: 500 }}>
              Branch:
            </div>
            <Select
              style={{ width: "100%" }}
              placeholder="Select Branch"
              value={selectedBranch?.id}
              onChange={handleBranchChange}
              loading={loading.branches}
            >
              {branches.map((branch) => (
                <Option key={branch.id} value={branch.id}>
                  {branch.name}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={12}>
            <div style={{ marginBottom: 8, fontWeight: 500 }}>
              Sales Executive:
            </div>
            <Select
              style={{ width: "100%" }}
              placeholder="Select Sales Executive"
              value={selectedExecutive?.id}
              onChange={handleExecutiveChange}
              disabled={!selectedBranch}
              loading={loading.employees}
            >
              {employees.map((employee) => (
                <Option key={employee.id} value={employee.id}>
                  {employee.name} ({employee.employeeId})
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default ReassignForm;